import {
  Req_GetPermissions
} from '@/request/permission'

export default {
  state: {
    permissions: []
  },
  mutations: {
    updatePermission(state,payload) {
      state.permissions = payload
    }
  },
  actions: {
    getPermissionList(store) {
      Req_GetPermissions().then(res => {
        store.commit('updatePermission',res)
      }).catch(err => this.$catchErr(err))
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/permission.js